export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7398.e957be1a.jpg";